var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useMemo } from "react";
import { useTheme } from "@emotion/react";
import { Loading } from "@bale/icons";
import classNames from "classnames";
import styles from "./NewButton.module.scss";
import { useRippleController } from "../ripple/hooks/useRippleController";
import TouchRipple from "../ripple/muiRipple/TouchRipple";
import { RippleColorNames } from "../../theme";
export var NewButtonVariant;
(function (NewButtonVariant) {
    NewButtonVariant["FILLED"] = "Filled";
    NewButtonVariant["OUTLINED"] = "Outlined";
    NewButtonVariant["TEXT"] = "Text";
})(NewButtonVariant || (NewButtonVariant = {}));
export var NewButtonSize;
(function (NewButtonSize) {
    NewButtonSize["FULL"] = "Full";
    NewButtonSize["LARGE"] = "Large";
    NewButtonSize["MEDIUM"] = "Medium";
    NewButtonSize["SMALL"] = "Small";
    NewButtonSize["XSMALL"] = "XSmall";
})(NewButtonSize || (NewButtonSize = {}));
export var NewButtonColor;
(function (NewButtonColor) {
    NewButtonColor["DEFAULT"] = "Default";
    NewButtonColor["ERROR"] = "Error";
})(NewButtonColor || (NewButtonColor = {}));
export const NewButton = (props) => {
    var _a, _b, _c;
    const theme = useTheme();
    const variant = props.size === NewButtonSize.FULL
        ? NewButtonVariant.FILLED
        : ((_a = props.variant) !== null && _a !== void 0 ? _a : NewButtonVariant.FILLED);
    const size = (_b = props.size) !== null && _b !== void 0 ? _b : NewButtonSize.MEDIUM;
    const color = props.size !== NewButtonSize.FULL && props.color
        ? props.color
        : NewButtonColor.DEFAULT;
    const iconColor = props.disabled || props.disabledJustColor
        ? theme.colors.dark["100"]
        : props.size === NewButtonSize.FULL
            ? props.isSecondary
                ? theme.colors.primary["50"]
                : theme.colors.light.on_primary
            : props.variant === NewButtonVariant.OUTLINED ||
                props.variant === NewButtonVariant.TEXT
                ? color === NewButtonColor.DEFAULT
                    ? theme.colors.primary["50"]
                    : theme.colors.error
                : theme.colors.light.on_primary;
    const iconSize = useMemo(() => {
        let size = 22;
        if (props.size === NewButtonSize.FULL) {
            size = 24;
        }
        else if (props.size === NewButtonSize.LARGE) {
            size = 24;
        }
        else if (props.size === NewButtonSize.MEDIUM) {
            size = 22;
        }
        else if (props.size === NewButtonSize.SMALL) {
            size = 20;
        }
        else {
            size = 18;
        }
        return size;
    }, [props.size]);
    const clickHandler = (event) => {
        var _a;
        if (props.loading) {
            // do nothing
        }
        else {
            (_a = props.onClick) === null || _a === void 0 ? void 0 : _a.call(props, event);
        }
    };
    const _d = useRippleController({}, {
        disableTouchRipple: props.disableRipple || props.disabled || props.disabledJustColor,
    }), { rippleRef } = _d, rippleHandlers = __rest(_d, ["rippleRef"]);
    return (React.createElement("button", Object.assign({ onClick: clickHandler, className: classNames(styles.Button, styles[size], styles[variant], styles[color], {
            [styles.disabled]: props.disabled || props.disabledJustColor,
            [styles.Secondary]: props.size === NewButtonSize.FULL && props.isSecondary,
            [styles.IsLoading]: props.loading,
        }, props.className), "data-testid": props["data-testid"], style: Object.assign({ direction: (_c = props.direction) !== null && _c !== void 0 ? _c : "inherit" }, props.style), disabled: props.disabled, "aria-label": props.text, id: props.id }, rippleHandlers),
        React.createElement(TouchRipple, { ref: rippleRef, center: false, rippleColor: props.variant == NewButtonVariant.FILLED
                ? RippleColorNames.color_primary_ripple
                : props.color === NewButtonColor.ERROR
                    ? RippleColorNames.color_error_ripple
                    : RippleColorNames.color_ripple }),
        props.loading && (React.createElement("div", { className: styles.LoadingWrapper },
            React.createElement(Loading, { className: styles.Loading, size: iconSize, color: iconColor }))),
        props.icon && (React.createElement(props.icon, { size: iconSize, color: iconColor, secondColor: iconColor })),
        props.text ? props.text : props.children));
};
//# sourceMappingURL=NewButton.js.map